import { trackEvent } from '@patrianna/analytics'
import { nextTick } from '@patrianna/shared-utils'
import { useEffect, useState } from 'react'

import { useAppDispatch } from 'src/store/hooks'
import { setDataToLocalStorage } from 'src/utils/localStorage'
import { resendEmailRequest } from 'store/modules/auth/actions'

export const THIRTY_MINUTES = 30 * 60 * 1000

const useResendEmail = () => {
  const [inProgress, setInProgress] = useState(false)
  const dispatch = useAppDispatch()

  const resendMail = () => {
    const expiration = new Date().getTime() + THIRTY_MINUTES

    nextTick().then(() => {
      trackEvent('email_verification_resent', {
        interaction_name: 'email_verification_resent',
      })
      setInProgress(true)
      dispatch(resendEmailRequest())
      dispatch(setDataToLocalStorage('TIME_OF_LINK_EXPIRATION', expiration.toString(), false))
    })
  }

  useEffect(() => {
    if (inProgress) {
      setTimeout(() => {
        setInProgress(false)
      }, 60000)
    }
  }, [inProgress])

  return {
    resendMail,
    inProgress,
  }
}

export default useResendEmail
